export enum ValidationConstants {
  SETUP_INPUT_VALIDATION = 'validation/SETUP_INPUT_VALIDATION',
  DO_INPUT_VALIDATION = 'validation/DO_INPUT_VALIDATION',
  RESET_VALIDATION_STATE = 'validation/RESET_VALIDATION_STATE',
  CONDITIONAL_VALUE = 'conditionalValue',
}
